<template>
  <div class="flex flex-col gap-6 flex-1 justify-center">
    <img
      class="mx-auto"
      style="width: 224px; height: 190px"
      src="@/app/ui/assets/svg/ill_spot_search.svg"
      alt="not_found"
    />
    <div class="flex flex-col gap-2 items-center">
      <p class="text-center text-gray-lp-300 text-sm font-semibold">
        Hasil pencarian tidak ditemukan
      </p>
      <p class="text-center text-gray-lp-600 text-sm font-light">
        Pastikan kata kunci yang Anda masukkan sudah sesuai
      </p>
    </div>
  </div>
</template>
 